import { Auth0ContextInterface, useAuth0, User } from '@auth0/auth0-react';
import { Auth0FrontendUser } from '@gr/shared/models';
import { getEquivalentRole } from '@gr/shared/utils';

export interface Auth0UserData extends Auth0ContextInterface<User> {
  user: Auth0FrontendUser;
}

export function useAuth0UserData(): Auth0UserData {
  const data = useAuth0();
  const user = data?.user as Auth0FrontendUser;

  return {
    ...(data ?? {}),
    user: {
      ...(user ?? {}),
      auth_roles: user?.auth_roles?.map(role => getEquivalentRole(role)) ?? [],
    },
  };
}